import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { MissionSection } from './components/MissionSection';
import { ServicesSection } from './components/ServicesSection';
import { SuccessStoriesSection } from './components/SuccessStoriesSection';
import { FoundersSection } from './components/FoundersSection';
import { NetworkSection } from './components/NetworkSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { RobFridPage } from './pages/RobFridPage';
import { ScottBlairPage } from './pages/ScottBlairPage';
const HomePage = () => <main data-id="element-0">
    <HeroSection data-id="element-1" />
    <MissionSection data-id="element-2" />
    <ServicesSection data-id="element-3" />
    <SuccessStoriesSection data-id="element-4" />
    <FoundersSection data-id="element-5" />
    <NetworkSection data-id="element-6" />
    <ContactSection data-id="element-7" />
  </main>;
export function App() {
  return <BrowserRouter data-id="element-8">
      <div className="min-h-screen bg-navy-900 text-white selection:bg-ice-500 selection:text-navy-900" data-id="element-9">
        <Navbar data-id="element-10" />
        <Routes data-id="element-11">
          <Route path="/" element={<HomePage data-id="element-13" />} data-id="element-12" />
          <Route path="/rob-frid" element={<RobFridPage data-id="element-15" />} data-id="element-14" />
          <Route path="/scott-blair" element={<ScottBlairPage data-id="element-17" />} data-id="element-16" />
        </Routes>
        <Footer data-id="element-18" />
      </div>
    </BrowserRouter>;
}